$(document).ready(function () {
  var refreshCart = function () {
    window.carts.forEach((cart) => {
      cart.onCartUpdated();
    });
  };

  refreshCart();

  var isAddingSingleProduct = false;
  var isAddingFreeProduct = false;
  var isAddingFreeProduct2 = false;
  var isAddingBundleFreeProduct = false;

  var autoFreeProduct = function (cart) {
    // if (cart.item_count == 0) {
    //   return false;
    // }
    var hasFreeSingleProduct = false;
    var freeSingleProductKey = null;
    var hasFreeProduct = false;
    var hasFreeProduct2 = false;
    var hasBundleFreeProduct = false;
    var bundleFreeProductKey = null;
    var freeProductKey = null;
    var elligibleProducts = theme.elligibleProducts.split(",");
    //var is_elligible = false;
    var elligible_count = 0;

    cart.items.forEach(function (item) {
      if (item.id == theme.freeSingleProduct) {
        hasFreeSingleProduct = true;
        freeSingleProductKey = item.key;
      } else if (theme.freeVariantIDs.includes(item.id)) {
        hasFreeProduct = true;
        freeProductKey = item.key;
      } else if (theme.enableFreeProduct2) {
        if (elligibleProducts.includes(item.product_id.toString())) {
          elligible_count += item.quantity;
        } else if (item.id == theme.freeProduct2) {
          hasFreeProduct2 = true;
        }
      }
      if (item.id == theme.bundleFreeProduct) {
        hasBundleFreeProduct = true;
        bundleFreeProductKey = item.key;
      }
    });

    var is_elligible =
      elligible_count >= theme.freeElligibleMinQty ? true : false;
    var free_product_threshold = Math.round(
      theme.freeProductThreshold * Shopify.currency.rate,
    );
    var free_single_product_threshold = Math.round(
      theme.freeSingleProductThreshold * Shopify.currency.rate,
    );

    var isFreeSingleGiftRemoved = sessionStorage.getItem(
      "isFreeSingleGiftRemoved",
    );
    var freegift_removed = sessionStorage.getItem("freegift_removed");
    var freegift2_removed = sessionStorage.getItem("freegift2_removed");
    var bundlefreegift_removed = sessionStorage.getItem(
      "bundlefreegift_removed"
    );

    // Single free product
    if (theme.enableFreeSingleProduct) {
      if (
        cart.total_price >= free_single_product_threshold &&
        hasFreeSingleProduct == false &&
        !isFreeSingleGiftRemoved &&
        !isAddingSingleProduct
      ) {
        isAddingSingleProduct = true;
        $.ajax({
          type: "POST",
          url: "/cart/add.js",
          data: {
            id: theme.freeSingleProduct,
            quantity: 1,
          },
          dataType: "json",
          success: function (res) {
            isAddingSingleProduct = false;
            document.dispatchEvent(new CustomEvent("productAddedToCart"));
            refreshCart();
          },
        });
      } else if (
        cart.total_price < free_single_product_threshold &&
        hasFreeSingleProduct == true
      ) {
        $.ajax({
          type: "POST",
          url: "/cart/change.js",
          data: { id: freeSingleProductKey, quantity: 0 },
          dataType: "json",
          success: function (res) {
            refreshCart();
          },
        });
      }
    }

    if (theme.enableFreeProduct) {
      if (cart.total_price < free_product_threshold && hasFreeProduct == true) {
        $.ajax({
          type: "POST",
          url: "/cart/change.js",
          data: { id: freeProductKey, quantity: 0 },
          dataType: "json",
          success: function (res) {
            refreshCart();
          },
        });
      }
    }

    if (theme.enableFreeProduct2) {
      if (
        is_elligible == true &&
        hasFreeProduct2 == false &&
        !freegift2_removed &&
        !isAddingFreeProduct2
      ) {
        isAddingFreeProduct2 = true;
        $.ajax({
          type: "POST",
          url: "/cart/add.js",
          data: {
            id: theme.freeProduct2,
            quantity: 1,
          },
          dataType: "json",
          success: function (res) {
            isAddingFreeProduct2 = false;
            document.dispatchEvent(new CustomEvent("productAddedToCart"));
            refreshCart();
          },
        });
      } else if (is_elligible == false && hasFreeProduct2 == true) {
        $.ajax({
          type: "POST",
          url: "/cart/change.js",
          data: { id: theme.freeProduct2, quantity: 0 },
          dataType: "json",
          success: function (res) {
            refreshCart();
          },
        });
      }

      if (
        is_elligible == true &&
        hasFreeProduct2 == false &&
        freegift2_removed
      ) {
        $("#cart-free-product2-card").removeClass("hide");
      } else if (is_elligible == false || hasFreeProduct2 == true) {
        $("#cart-free-product2-card").addClass("hide");
      }
    }

    if (theme.enableBundleFreeProduct) {
      let totalOneDayQuantity = 0;
      let totalThreeMonthQuantity = 0;

      cart.items.forEach((item) => {
        if (
          item.properties &&
          item.properties._bundle_tag === "Period__1-Day" &&
          item.properties._is_bundle_product
        ) {
          totalOneDayQuantity += item.quantity;
        }
        if (
          item.properties &&
          item.properties._bundle_tag === "Period__3-Month" &&
          item.properties._is_bundle_product
        ) {
          totalThreeMonthQuantity += item.quantity;
        }
      });

      const isEligibleForBundleFreeProduct =
        totalOneDayQuantity >= theme.freeOneDayMinQty ||
        totalThreeMonthQuantity >= theme.freeThreeMonthMinQty;

      if (
        !hasBundleFreeProduct &&
        isEligibleForBundleFreeProduct &&
        !bundlefreegift_removed &&
        !isAddingBundleFreeProduct
      ) {
        isAddingBundleFreeProduct = true;
        $.ajax({
          type: "POST",
          url: "/cart/add.js",
          data: {
            id: theme.bundleFreeProduct,
            quantity: 1,
          },
          dataType: "json",
          success: function (res) {
            isAddingBundleFreeProduct = false;
            document.dispatchEvent(new CustomEvent("productAddedToCart"));
            refreshCart();
          },
        });
      } else if (hasBundleFreeProduct && !isEligibleForBundleFreeProduct) {
        $.ajax({
          type: "POST",
          url: "/cart/change.js",
          data: { id: bundleFreeProductKey, quantity: 0 },
          dataType: "json",
          success: function (res) {
            refreshCart();
          },
        });
      }
      if (
        isEligibleForBundleFreeProduct &&
        !hasBundleFreeProduct &&
        bundlefreegift_removed
      ) {
        $("#cart-bundle-free-product").removeClass("hide");
      } else if (hasBundleFreeProduct || !isEligibleForBundleFreeProduct) {
        $("#cart-bundle-free-product").addClass("hide");
      }
    }
  };

  $(document).on("change", ".cart-drawer__input", function () {
    var $input = $(this);
    var qty = $input.val();
    var previousQty = $input.data("previous-value");
    var _itemRow = $input.closest(".cart-drawer__item");
    var item_key = _itemRow.data("cart-item");
    var $buttons = _itemRow.find(".add, .sub");
    $buttons.addClass("disabled");

    $.ajax({
      type: "POST",
      url: "/cart/change.js",
      dataType: "json",
      data: {
        quantity: qty,
        id: item_key,
      },
      success: function () {
        refreshCart();
      },
      error: function (err) {
        $input.val(previousQty);
        cartDrawerErrorHandling(err, _itemRow);
      },
      complete: function () {
        setTimeout(() => {
          $buttons.removeClass("disabled");
        }, 500);
      },
    });
  });

  const cartDrawerErrorHandling = (err = null, $currentRow) => {
    const errorMessage = err?.responseJSON?.description;
    const $errorContainer = $currentRow.find(".cart-drawer__error");
    $errorContainer.text(errorMessage).fadeIn();
  };

  //Add cross-sell product to the cart-drawer
  $(".drawer-addtocart").on("click", function () {
    var _this = $(this);
    _this.closest(".addons-wrap").addClass("disabled");
    _this.closest(".cart-drawer__offer-box").addClass("disabled");
    $.ajax({
      type: "POST",
      url: "/cart/add.js",
      data: {
        id: _this.data("variant_id"),
        quantity: 1,
      },
      dataType: "json",
      success: function (res) {
        document.dispatchEvent(new CustomEvent("productAddedToCart"));
        refreshCart();
        _this.closest(".item").hide();

        var hide_block = true;
        $(".cart-drawer__cross-sell-products .item").each(function () {
          if ($(this).is(":visible")) {
            hide_block = false;
            return;
          }
        });
        if (hide_block) {
          $(".cart-drawer__cross-sell-products").hide();
        }
        setTimeout(()=>{
        _this.closest(".addons-wrap").removeClass("disabled");
        }, 1000)
        _this.closest(".cart-drawer__offer-box").removeClass("disabled");
      },
    });
  });

  //Add/remove free products automatically whenever there is any change in the cart
  $(document).on("autoFreeProduct", function (event) {
    var cart = event.detail;
    /*if(theme.enableFreeProduct == false || cart.item_count == 0){
      return false;
    } */
    autoFreeProduct(cart);
  });

  $(document).on("click", ".btn-package-content", function () {
    const bundleItems = $(this).next(".bundle-items");
    bundleItems.toggleClass("show");
    if (bundleItems.hasClass("show")) {
      $(this).find("svg").addClass("rotate");
    } else {
      $(this).find("svg").removeClass("rotate");
    }
  });
});
